import { Provider } from 'tinybase/ui-react';
import syncStoreService from '@/store/syncStore/SyncStoreService';

import { Inspector } from 'tinybase/ui-react-inspector';
import { useSelector } from 'react-redux';
import { selectShowInspector } from '@/state/general/generalSelectors';
import { RootState } from '@/store/store';

const TinyBaseProvider = ({ children }) => {
    const env = import.meta.env.REACT_APP_ENVR;
    const inspector = useSelector((state: RootState) => selectShowInspector(state));

    return (
        <Provider
            store={syncStoreService.getStore()}
            metrics={syncStoreService.getMetrics()}
            queries={syncStoreService.getQueries()}
            relationships={syncStoreService.getRelationships()}
        >
            {children}
            {(env === 'dev' || env === 'beta' || inspector) && <Inspector />}
        </Provider>
    );
};

export default TinyBaseProvider;
